import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, convertToNumber, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, FormButton, ImportButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { CommonApiData } from '../CommonComponents/EnvConfig';

const AssetProductMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [isLoading, setIsLoading] = useState(false)
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        assetProductMasterID: '',
        assestProductCode: 'System Generated',
        productFamilyCode: '',
        productCode: '',
        assetTypeCode: '',
        assetCode: '',
        assetValueRangeFrom: '',
        assetValueRangeTo: '',
        mrpIncludingTax: '',
        extendedWarrantPeriod: '',
        identifierForIssuance: '',
        isActive: true,
        productDescription: ''
    });
    const GeDealerType = DropDownData('GetDealerTypeMaster')
    const GetProductFamilyCode = DropDownData('GetProductFamilyMaster')

    const GetProductCode = DropDownData('GetProductCode', formData.productFamilyCode)
    const getAssetProductMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            productFamilyCode: formData.productFamilyCode || '',
            productCode: formData.productCode || '',
            dealerType: formData.dealerType || '',
            assetTypeCode: formData.assetTypeCode || '',
            assetCode: formData.assetCode || '',
            assestProductName: formData.assestProductName || '',
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowAssetProductMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async () => {
        await setFormData({
            assetProductMasterID: '',
            assestProductCode: 'System Generated',
            productFamilyCode: '',
            productCode: '',
            assetTypeCode: '',
            assetCode:'',
            assetValueRangeFrom: '',
            assetValueRangeTo: '',
            mrpIncludingTax: '',
            extendedWarrantPeriod: '',
            identifierForIssuance: '',
            isActive: true,
            productDescription: ''
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        await setSortConfig({ SortColumn: null, SortOrder: null })
        filterData.SearchText = '';
    }

    const handleSubmit = async () => {
        const rangeFrom = parseFloat(formData.assetValueRangeFrom);
        const rangeTo = parseFloat(formData.assetValueRangeTo);
        if (rangeFrom > rangeTo) {
            NotificationSound("Error", 'Asset Value Range (From) should be less than  Asset Value Range (To)', 'txtAssetValueRangeTo', inputrefs);
        } else {
            await dispatch(setSubLoading(true))
            let data = await ApiCall(`/api/Master/InsertUpdateAssetProductMaster`, { ...formData })
            await dispatch(setSubLoading(false))
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        };
    }

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditAssetProductMaster`, { assetProductMasterID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteAssetProductMaster`, { assetProductMasterID: id }, getAssetProductMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getAssetProductMasterData(value);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('ProductPriceMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'ProductPriceMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            assestProductCode: 'System Generated',
        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("productFamilyCode", "productCode", "assetTypeCode","assetCode", "identifierForIssuance", "assetValueRangeFrom", "assetValueRangeTo", "mrpIncludingTax", "extendedWarrantPeriod", "productDescription", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateAssetProductMaster', ImportData, Data2, getAssetProductMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    useEffect(() => {
        const delay = setTimeout(() => {
            getAssetProductMasterData();
        }, 500);
        return () => clearTimeout(delay);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortConfig,
        formData.productFamilyCode,
        formData.productCode,
        formData.dealerType,
        formData.assetTypeCode,
        formData.assetCode,
    ])

    useEffect(() => {
        document.title = 'Product Price Master'
        inputrefs.current['txtProductFamilyCode'].focus()
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Product Price Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <SelectInputBox
                                    id="txtProductFamilyCode"
                                    value={formData.productFamilyCode}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label='Product Family'
                                    required={true}
                                    onChange={(e) =>
                                        setFormData({ ...formData, productFamilyCode: e.target.value, assetCode: "" })

                                    }
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtProductCode'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetProductFamilyCode?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>

                                <SelectInputBox
                                    id="txtProductCode"
                                    value={formData.productCode}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label='Product'
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, productCode: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtDealerType'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetProductCode?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>

                                <SelectInputBox
                                    id="txtDealerType"
                                    value={formData.dealerType}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1 d-none"
                                    label='Dealer Type'
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, dealerType: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssetTypeCode'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GeDealerType?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>
                                <AutoCompleteBoxNew
                                    id="txtAssetTypeCode"
                                    placeholder="Asset Type"
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label={'Asset Type'}
                                    required={true}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssetCode'].focus()
                                        }
                                    }}
                                    contextKey={formData.productFamilyCode}
                                    autocompleteType='GetAssetTypeMaster'
                                    value={formData.assetTypeCode || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, assetTypeCode: newInputValue })
                                        }
                                    }}
                                    maxLength='50'
                                />

                                <AutoCompleteBoxNew
                                    id="txtAssetCode"
                                    placeholder="Asset"
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label={'Asset'}
                                    required={true}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssestProductName'].focus()
                                        }
                                    }}
                                    contextKey={formData.assetTypeCode}
                                    autocompleteType='GetAssetByAssetTypeMaster'
                                    value={formData.assetCode || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, assetCode: newInputValue })
                                        }
                                    }}
                                    maxLength='50'
                                />


                                <InputBox
                                    id="txtAssetProductCode"
                                    type="text"
                                    label='Asset Product Code'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1 d-none"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssestProductName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='System Generated'
                                    name='Assest Product '
                                    value={formData.assestProductCode}
                                    disabled
                                />


                                <InputBox
                                    id="txtIdentifierForIssuance"
                                    type="text"
                                    label='Identifier For Issuance'
                                    placeholder="Identifier For Issuance"
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    maxLength='10'
                                    value={formData.identifierForIssuance}
                                    onChange={(e) => setFormData({ ...formData, identifierForIssuance: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssetValueRangeFrom'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtAssetValueRangeFrom"
                                    type="text"
                                    label='Asset Value Range From'
                                    required={true}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    placeholder="Asset Value Range From"
                                    maxLength='7'
                                    value={formData.assetValueRangeFrom}
                                    onChange={(e) => setFormData({ ...formData, assetValueRangeFrom: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssetValueRangeTo'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtAssetValueRangeTo"
                                    type="text"
                                    label='Asset Value Range To'
                                    required={true}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    placeholder="Asset Value Range To"
                                    maxLength='7'
                                    value={formData.assetValueRangeTo}
                                    onChange={(e) => setFormData({ ...formData, assetValueRangeTo: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtMrpIncludingTax'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtMrpIncludingTax"
                                    type="text"
                                    label='Mrp Including Tax'
                                    required={true}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    placeholder="Mrp Including Tax"
                                    value={formData.mrpIncludingTax}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^\d{0,6}(\.\d{0,3})?$/;
                                        if (regex.test(value) || value === '') {
                                            setFormData({ ...formData, mrpIncludingTax: value });
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtExtendedWarrantPeriod'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtExtendedWarrantPeriod"
                                    type="text"
                                    label='Extended Warrant Period'
                                    placeholder="Extended Warrant Period"
                                    required={true}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    maxLength='2'
                                    value={formData.extendedWarrantPeriod}
                                    onChange={(e) => {
                                        const value = convertToNumber(e.target.value);
                                        if (parseInt(value, 10) <= 10 || value === '') {
                                            setFormData({ ...formData, extendedWarrantPeriod: value });
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                />

                                <div className="col-lg-6 col-md-6 col-sm-12 mb-2 ">
                                    <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" >Product Description</label>
                                    <textarea
                                        id="txtDescription"
                                        ref={ref => (inputrefs.current["txtDescription"] = ref)}
                                        className="col-lg-6 col-md-6 col-sm-12 form-control"
                                        placeholder="Text here...."
                                        cols={500}
                                        value={formData.productDescription}
                                        onChange={(e) => setFormData({ ...formData, productDescription: e.target.value })}
                                    />
                                </div>
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />

                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/Master/ShowAssetProductMaster`, filterData, 'Product Price Master')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'ProductPriceMaster'}
                handleFilter={() => {
                    getAssetProductMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default AssetProductMaster;